// eslint-disable-next-line
import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {  Link, useHistory } from 'react-router-dom';
window.Buffer = window.Buffer || require("buffer").Buffer;

// Material-UI components
import {
    Button,
    Typography,
    CircularProgress,
    Select,
    MenuItem,
    SelectChangeEvent,
    Box,
    Dialog,
    DialogTitle,
    DialogActions,
} from '@mui/material';
import { BrandedCardContainer } from '../../components/BrandedCardContainer/BrandedCardContainer';
// Constants
import { INVITE_USER_TYPE_KEY, LOGIN_ATTEMPTS, LOGIN_PLATFORM } from '../../constants';
import * as PXBColors from '@brightlayer-ui/colors';
import BackgroundImage from '../../assets/images/Login_Background.png';
import cyberCertifyLogo from '../../assets/images/cybersecurity_certified.svg';
import ProjectName from '../../assets/images/safety-management-system.svg'
import LanguageIcon from '../../assets/images/language-icon.svg'
import {
    useAuthState,
    isAuthenticated,
    useAuthHelper,
    getRememberMe,
    getUserEmail,
    getUserId,
    getUserRoleType,
} from '../../components/AuthContextProvider';
import { Actions, Thunks } from '../../actions';
import { Selectors } from '../../selectors';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { EmptyState } from '@brightlayer-ui/react-components';
import { toBase64 } from '../../lib/encrypt-helpers';
import { getInviteUserModel, INVITE_USER_TYPE, LANGUAGE, USER_ROLE_TYPE } from '../enum/ENUM';
import { COLOR_GRAY_ICON } from '../../constants/color-codes';
import { pushAppRoute } from '../../data/domain/route-manager';
import './main.css';
import { getLanguageList, getLanguageListvalue, languageList } from '../../components/UserDetails/AccountPreferencesData';
import i18n from '../../data/translations/i18n';
import { SessionStorage } from '../../components/AuthContextProvider/session-storage';
import { OktaRedirectLoginScreenProps } from '@brightlayer-ui/react-auth-workflow/dist/screens/OktaRedirectLoginScreen/types';
import { getOktaRedirectLoginScreenUtilityClass, OktaRedirectLoginScreenClassKey } from '@brightlayer-ui/react-auth-workflow/dist/screens/OktaRedirectLoginScreen/utilityClasses';
import { unstable_composeClasses as composeClasses } from '@mui/base';
import { useOktaAuth } from '@okta/okta-react';
import { DialogContent } from '@material-ui/core';
import { signalRRegistration } from '../../components/SignalR/signalRComponent';

export const useUtilityClasses = (
    ownerState: OktaRedirectLoginScreenProps
): Record<OktaRedirectLoginScreenClassKey, string> => {
    const { classes } = ownerState;

    const slots = {
        root: ['root'],
        projectImageWrapper: ['projectImageWrapper'],
        loginButtonWrapper: ['loginButtonWrapper'],
        loginButton: ['loginButton'],
        forgotPasswordWrapper: ['forgotPasswordWrapper'],
        forgotPasswordLabel: ['forgotPasswordLabel'],
        selfRegisterWrapper: ['selfRegisterWrapper'],
        selfRegisterInstructionLabel: ['selfRegisterInstructionLabel'],
        selfRegisterLabel: ['selfRegisterLabel'],
        contactSupportWrapper: ['contactSupportWrapper'],
        contactSupportLabel: ['contactSupportLabel'],
        cyberSecurityBadgeWrapper: ['cyberSecurityBadgeWrapper'],
        cyberSecurityBadge: ['cyberSecurityBadge'],
    };

    return composeClasses(slots, getOktaRedirectLoginScreenUtilityClass, classes);
};

export const Login: React.FC<React.PropsWithChildren<React.PropsWithChildren<unknown>>> = (props) => {
    const history = useHistory();
    const { t } = useLanguageLocale();
    const authStates = useAuthState();
    const authHelper = useAuthHelper();
    const dispatch = useDispatch();
    const userId = getUserId(authStates);
    const inActiveLogoutMessage = useSelector(Selectors.Dashboard.inActiveLogOut);
    const loginState = useSelector(Selectors.Authentication.login);
    const loginUserInfo = useSelector(Selectors.Authentication.loginUserInfo);
    const rememberMeChecked = getRememberMe(authStates);
    const rememberMeEmail = getUserEmail(authStates) || '';
    const [inActiveLogout, setInactiveLogOut] = useState(inActiveLogoutMessage);
    const [email, setEmail] = useState<string>(rememberMeEmail);
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(rememberMeChecked);
    const [selectedLanguage, setSelectedLanguage] = React.useState(getLanguageList(SessionStorage.readLanguage()).value);
    const [selectedLanguageKey, setSelectedLanguageKey] = React.useState(getLanguageList(SessionStorage.readLanguage()).key);
    const [changeLanguageState, setChangeLanguageState] = React.useState(true);
    const registrationLink = "/register/" + toBase64(INVITE_USER_TYPE_KEY + INVITE_USER_TYPE.TYPE_NEW_USER_SELF_REGISTER) + "/" + getInviteUserModel(INVITE_USER_TYPE.TYPE_NEW_USER_SELF_REGISTER).value + "/";
    const { authState, oktaAuth } = useOktaAuth();
    const defaultClasses = useUtilityClasses(props);
    const [isLoading, setIsLoading] = useState(!authState);
    const usertype = getUserRoleType(useAuthState()) || '';


    useEffect(() => {
        i18n.changeLanguage(getLanguageListvalue(selectedLanguage).code);
        setChangeLanguageState(false);
    }, [navigator.language, changeLanguageState, getLanguageList(SessionStorage.readLanguage()).value]) // eslint-disable-line react-hooks/exhaustive-deps

    const goToRegistration = (usertype: string, email: string): void => {
        pushAppRoute(history, { type: 'Registration', inviteUserType: usertype, inviteUserEmail: email });
    };

    const effectRan = useRef(false);

    useEffect(() => {
        if (effectRan.current === false) {
            if (authState?.isAuthenticated && authState.accessToken !== undefined) {
                SessionStorage.saveAuthToken(authState.accessToken.accessToken);

                if (authState?.accessToken?.claims?.email) {
                    setEmail(authState.accessToken.claims.email);
                }
                dispatch(Thunks.Authentication.loginUserInfo('', '', false, authHelper.onUserAuthenticated, LOGIN_PLATFORM, '', selectedLanguageKey));
            }
            effectRan.current = true;
        }
    }, [authState, oktaAuth, dispatch, authHelper, selectedLanguageKey]);

    useEffect(() => {
        // eslint-disable-next-line
        if (authState?.isAuthenticated && loginUserInfo.loginUserInfoSuccess) {
            if (loginUserInfo.loginUserInfo.profileStatus === 1)  //complete
            {
                signalRRegistration()
               
                if(usertype==USER_ROLE_TYPE.ARCHIVED_USER){
                    history.push('/settings/0')
                }else{
                    history.push('/dashboard');
                }
                
            }
            else if (loginUserInfo.loginUserInfo.profileStatus === 2)   // Incomplete
            {
                goToRegistration(toBase64(INVITE_USER_TYPE_KEY + INVITE_USER_TYPE.TYPE_NEW_USER_INCOMPLETE_REGISTER), email);
            }
            else if (loginUserInfo.loginUserInfo.profileStatus === 3)   // Other adaptor
            {
                goToRegistration(toBase64(INVITE_USER_TYPE_KEY + INVITE_USER_TYPE.TYPE_NEW_OTHER_ADOPTER_USER_INCOMPLETE_REGISTER), email);
            }
        }
    }, [loginUserInfo.loginUserInfoLoading, loginUserInfo.loginUserInfoSuccess, loginUserInfo.loginUserInfoFail, authState]); // eslint-disable-line react-hooks/exhaustive-deps

    const onLogIn = async (): Promise<void> => {
        setInactiveLogOut(false);
        await dispatch(Thunks.Authentication.login(email, password, remember, authHelper.onUserAuthenticated, LOGIN_PLATFORM, '', selectedLanguageKey));
        sessionStorage.setItem(LOGIN_ATTEMPTS, '1');
        signalRRegistration();
    };

    const selectionLanguageChangeHandler = (event: SelectChangeEvent) => {
        setSelectedLanguage(event.target.value as string);
        const language = getLanguageListvalue(event.target.value as string);
        setSelectedLanguageKey(language.key);
        i18n.changeLanguage(language.code);
        SessionStorage.saveLanguage(language.code || LANGUAGE.ENGLISH);
    };
    const logOutUser = async () => {
        if (authState) {
            await authState.isAuthenticated && oktaAuth.signOut();
            await oktaAuth.revokeAccessToken(authState.accessToken);
        }
        dispatch(Thunks.Authentication.logout(userId, history, authHelper.onUserNotAuthenticated, authHelper));

    };

    const handleOnLogin = async (): Promise<void> => {
        try {
            setInactiveLogOut(false);
            setIsLoading(true);
            await oktaAuth.signInWithRedirect();
            //TODO- remove commented code later
            // await oktaAuth.signInWithRedirect().then((response)=>{
            //     console.log("Signin called done", JSON.stringify(response));
            //     console.log("Session token", sessionStorage.getItem('idToken'))
            // });
            // setTimeout(() => {
            //     console.log("token",  oktaAuth.getAccessToken());
            // }, 1000);

            // console.log("isAuthenticated", authState?.isAuthenticated);

            // console.log("sa",authState?.accessToken);

            // await oktaAuth.signInWithRedirect().then((response) => {
            //     console.log("Singin ", JSON.stringify(response));
            // });
            // // await props.onLogin?.();
            // await oktaAuth.isAuthenticated().then(async (response) => {
            //     console.log("scusses",  JSON.stringify(response));
            //     console.log("token", oktaAuth.getAccessToken());
            //     oktaAuth.getUser().then((response) => {
            //         console.log(response);
            //     })
            // });
            // await oktaAuth.getUser().then((response) => {
            //     console.log(response);
            // })

        } catch (_error) {
            // eslint-disable-next-line no-console
            console.log(_error as Error);
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <BrandedCardContainer data-testid="login-container">
                <>
                    {loginState.loading || loginUserInfo.loginUserInfoLoading && <EmptyState style={{ flex: 1, backgroundColor: PXBColors.white[50] }}
                        icon={<CircularProgress id="progress-spinner" />} title={t('LABELS.LOGGING_IN')} placeholder={undefined} />
                    }
                    {loginUserInfo.loginUserInfoFail && <Dialog open={loginUserInfo.loginUserInfoFail}>

                        <DialogTitle>{t('LOGIN.UNAUTHORIZED_ACCESS')}</DialogTitle>
                        <DialogContent>
                            <Typography variant="body1" style={{}}>
                                {t('LOGIN.UNAUTHORIZED_ACCESS_MESSAGE')}</Typography>
                        </DialogContent>
                        <DialogActions style={{ padding: '10' }}>
                            <Button
                                onClick={() => {
                                    logOutUser();
                                }}
                                color="primary"
                                autoFocus
                            >
                                {t('ACTIONS.OKAY')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    }
                    {!loginState.loading &&
                        <form
                            onSubmit={(evt): void => {
                                evt.preventDefault();
                                onLogIn();
                            }}
                        >
                            <div style={{ padding: '0px' }} data-testid="login-form">
                                <div
                                    className="bg_image"
                                    style={{
                                        backgroundImage: `url(${BackgroundImage})`,
                                        backgroundSize: 'cover',
                                        top: '150px',
                                        height: '150px',
                                        color: '#FFFFFF',
                                    }}
                                >
                                    <div style={{ display: 'flex' }}>
                                        <img
                                            data-testid="logo"
                                            style={{ paddingTop: 50, paddingLeft: 50, paddingRight: '30px', display: 'flex', flexDirection: 'column' }}
                                            src={ProjectName}
                                            alt="logo"
                                        />
                                    </div>
                                </div>
                                {inActiveLogout && (
                                    <Typography
                                        variant="subtitle1"
                                        color="error"
                                        style={{ paddingBottom: 10, paddingLeft: 25 }}
                                    >
                                        {t('INACTIVITY.INACTIVE_LOGOUT')}
                                    </Typography>
                                )}
                            </div>
                            <div style={{ padding: '0px 40px', marginTop: 80, display: 'flex', flexDirection: 'column' }}>
                                                      
                                <Box
                                    sx={{
                                        my: 5,
                                    }}
                                    className={defaultClasses.loginButtonWrapper}
                                    data-testid={defaultClasses.loginButtonWrapper}
                                >
                                    <Button
                                        className={defaultClasses.loginButton}
                                        data-testid={defaultClasses.loginButton}
                                        onClick={(): void => {
                                            void handleOnLogin();
                                        }}
                                        variant="contained"
                                        color="primary"
                                        sx={{
                                            width: '100%',
                                        }}
                                    >
                                        {t('LABELS.SIGN_IN')}
                                    </Button>
                                </Box>
                                <div style={{ textAlign: 'center', paddingBottom: '2%', paddingTop: '5%' }}>

                                    <Select
                                        style={{ width: 135, height: 38, borderRadius: 32, backgroundImage: `url(${LanguageIcon})`, backgroundRepeat: 'no-repeat', backgroundPosition: ' 8% 50%', paddingLeft: '5%', color: PXBColors.blue[500], borderStyle: 'none', borderColor: PXBColors.blue[500] }}
                                        labelId="primary-select-label"
                                        id="primary-select-label"
                                        data-testid='primary-select-label'
                                        value={selectedLanguage}
                                        onChange={selectionLanguageChangeHandler}

                                    >
                                        {languageList.map((option) => (
                                            <MenuItem sx={{}}
                                                key={option.key} value={option.value} data-testid={option.value}
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'left', fontSize: 16,
                                                    fontWeight: 400,
                                                    overflow: 'hidden',
                                                    boxSizing: 'border-box',
                                                    whiteSpace: 'nowrap',
                                                    minHeight: 48,
                                                    paddingTop: 6,
                                                    paddingBottom: 6,
                                                    width: 'auto',
                                                    paddingLeft: 16,
                                                    paddingRight: 16,
                                                    borderColor: PXBColors.blue[500]
                                                }}>
                                                {option.value}
                                            </MenuItem>
                                        ))}
                                    </Select>

                                </div>

                                <div data-testid="bottom-area" style={{ textAlign: 'center', paddingBottom: '2%', paddingTop: '5%' }}>
                                    <Typography variant="body2" style={{ color: COLOR_GRAY_ICON }}>
                                        {t('LABELS.NEED_ACCOUNT')}
                                        <Link
                                            style={{
                                                fontWeight: 600,
                                                textTransform: 'none',
                                                color: PXBColors.blue[500],
                                                fontSize:24
                                            }}
                                            to={registrationLink} data-testid="signup-link">
                                            {t('LABELS.SIGN_UP')}
                                        </Link>
                                    </Typography>
                                    <br />
                                </div>
                                <div style={{ textAlign: 'center' }} data-testid="cyber-logo">
                                    <img src={cyberCertifyLogo} alt="logo" />
                                </div>
                            </div>
                        </form>
                    }
                </>
            </BrandedCardContainer>
        </>
    );
};
